exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--oHjlL {\n  max-width: 1200px;\n  margin: 0 10px;\n}\n\n.header--3hiCt {\n  width: 100%;\n  max-width: 0 auto;\n  padding: 0 20px 20px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--oHjlL",
	"header": "header--3hiCt"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Private/pages/workflow-client/pages/Emission/Emission.m.scss
// module id = 1426
// module chunks = 0